export default function () {
    const widgetName = 'multiScheduleFeature';
    const widgetOpts = multiScheduleFeatureOpts;
  
    $(`#${widgetName}`).append('<div class="multiFeatureContent"></div>');

    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
  
    function formatDate(dateString) {
      const date = dateString.text().split(",")[0];
      let formatDate = null;
      if (date.includes(" - ")) {
        const [startDate, endDate] = date.split(" - ");
        const [startMonth, startDay] = startDate.split(" ");
        const fullMonth = months.find(month => month.startsWith(startMonth));
        formatDate = `${fullMonth} ${startDay} - ${endDate}`;
        return dateString.html(formatDate);
      }
      const [month, day] = date.split(" ");
      const fullMonth = months.find(m => m.startsWith(month));
      return dateString.html(`${fullMonth} ${day}`);
    }
  
    $(`#${widgetName}`).MultiScheduleFeature({
      scriptPath: widgetOpts.scriptPath,
      currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID,
      detectIpad: IPADDETECTED,
      isResponsive: false,
      allEventsLink: true,
      allEventsLinkText: 'VIEW FULL CALENDAR',
      hasImages: false,
      imageBackground: false,
      lazyLoadImages: true,
      buyNowButton: { visible: false, text: 'BUY NOW' },
      moreButton: { visible: false, text: 'MORE' },
      maxItemsVisible: 5,
      hasDescription: false,
      textContainer: true,
      link: 'all', // options are 'all', 'text', 'image', 'imageAndText', or ''
      attributeOrder: {
        1: 'image',
        2: 'title',
        3: 'date',
        4: 'description',
        5: 'buttons',
      },
      multiFeatureLoaded: function () {

        $(`#${widgetName} .featureItem`).each(function() {
          const eventDate = $(this).find('.featureItemDate');
          formatDate(eventDate);
        });
      
        setTimeout(() => {
          const featureItems = $(`#${widgetName} .featureItem`);
          featureItems.each(function() {
            const eventDate = $(this).find('.featureItemDate');
            formatDate(eventDate);
            
            const itemTitle = $(this).find('.featureItemTitle');
            if (itemTitle.length) {
              const limitedTitle = setCharLimit(itemTitle, 30);
              itemTitle.text(limitedTitle);
            }
          });
        }, 1000);      
        
        // arguments: data
        // console.log(data);
        // $(`#${widgetName} .featureItem`).each(function(i) {
        // const itemTitle = $(this).find('.featureItemTitle');
        // const itemDescripton = $(this).find('.featureItemDescription');
        /* uncomment below if you need to slice the date string up into something shorter like "Oct 31" */
        // const eventDate = $(this).find('.featureItemDate');
        // formatDate(eventDate);
        /* uncomment below if you need to limit the characters in the title or description text */
        // itemDescripton.text(setCharLimit(itemDescripton, 100));
        /* uncomment below if 'more' text is needed after event description */
        // itemDescripton.append("<span class='more-text'>More</span>");
        // });
      },
    });
  }
  
  // helper functions
  
  // function setCharLimit(el, limit) {
  //   const text = el.text();
  //   return text.length > limit ? `${text.substring(0, limit)}...` : text;
  // }

  function setCharLimit(el, limit) {
    const text = el.text();
    return text.length > limit ? `${text.substring(0, limit)}` : text;
  }
  
  function formatDate(el) {
    const datesMonth = el.text().slice(0,3);
    const datesDay = el.text().slice(4,7).replace(',','');
    el.html(`${datesMonth}<span>${datesDay}</span>`);
  }